/*------------------------------------------------------------------------------------------------------------------
about：时间处理函数
author：马兆铿
date：2017-11-16
* -----------------------------------------------------------------------------------------------------------------*/

// 延时
const sleep = time =>
  new Promise((resolve => {
    setTimeout(resolve, time)
  }))

export {
  sleep
}



// WEBPACK FOOTER //
// ./src/utils/time.js